"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function includesAll(arr, requiredArr) {
    if (!Array.isArray(arr) || !Array.isArray(requiredArr)) {
        return false;
    }
    for (var _i = 0, requiredArr_1 = requiredArr; _i < requiredArr_1.length; _i++) {
        var element = requiredArr_1[_i];
        if (!arr.includes(element)) {
            return false;
        }
    }
    return true;
}
exports.default = includesAll;
//# sourceMappingURL=includesAll.js.map